import React from 'react'

import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined'
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined'

export interface AccountSidePanelItem {
    index: number
    label: string
    path: string
    icon: React.ReactElement
}

export const ACCOUNT_SIDE_PANEL_ITEMS: AccountSidePanelItem[] = [
    {
        index: 0,
        label: 'myBookings',
        path: '/trips',
        icon: React.createElement(ConfirmationNumberOutlinedIcon)
    },
    {
        index: 1,
        label: 'wallet',
        path: '/wallet',
        icon: React.createElement(AccountBalanceWalletOutlinedIcon)
    },
    {
        index: 2,
        label: 'profile',
        path: '/profile',
        icon: React.createElement(AccountCircleOutlinedIcon)
    },
    {
        index: 3,
        label: 'travellers',
        path: '/travellers',
        icon: React.createElement(GroupOutlinedIcon)
    },
    // Settings temporarily disabled
    // {
    //     index: 4,
    //     label: 'settings',
    //     path: '/settings',
    //     icon: React.createElement(SettingsOutlinedIcon)
    // }
]

